import { ConsoleRoutePlaceholder } from '../features/console';

interface ConsolePlaceholderPageProps {
  title: string;
  description: string;
  bullets?: string[];
}

export function ConsolePlaceholderPage({ title, description, bullets }: ConsolePlaceholderPageProps) {
  return <ConsoleRoutePlaceholder title={title} description={description} bullets={bullets} />;
}
